




































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListMenuAddress from '@/components/common/search/ListMenuAddress.vue';
import { API_SEARCH_MENU_ADDRESS } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlMenuAddress',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListMenuAddress,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: 'メニュー',
    },
    widthCd: {
      type: Number,
      default: 53,
    },
    widthName: {
      type: Number,
      default: 340,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    API_SEARCH_MENU_ADDRESS,
    listMenuAddressShow: false,
    pageId: 0,
    pageMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { pageId, pageMei } = item;
      this.pageId = pageId;
      this.pageMei = pageMei;
      this.listMenuAddressShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listMenuAddressShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.pageId = value;
      if (value) {
        this.getMenuAddressItem();
      } else {
        this.pageMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ pageId: this.pageId });
      }
    },
    getMenuAddressItem() {
      axios
        .get(API_SEARCH_MENU_ADDRESS, { params: { pageId: this.pageId } })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.pageMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk && this.callbackOk({ pageId: this.pageId });
            return;
          }
          this.errors = clearNoDataError();
          const { pageMei } = res.data[0];
          this.pageMei = pageMei;
          this.callbackOk && this.callbackOk(res.data[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [pageId] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.pageId': {
      handler(newValue) {
        if (+newValue === +this.pageId) return;
        this.pageId = +newValue;
        if (newValue) {
          this.getMenuAddressItem();
        } else {
          this.pageMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.pageId) {
      this.pageId = +this.$attrs.pageId;
    }
  },
});
